import { render, staticRenderFns } from "./ItemsViewItemType.vue?vue&type=template&id=5c7a74e0&scoped=true"
import script from "./ItemsViewItemType.vue?vue&type=script&lang=js"
export * from "./ItemsViewItemType.vue?vue&type=script&lang=js"
import style0 from "./ItemsViewItemType.vue?vue&type=style&index=0&id=5c7a74e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7a74e0",
  null
  
)

export default component.exports